// 第三方訂單-Error message
export const THIRD_PARTY_ORDER_ERROR_CODES = {
  /** UNKNOWN_ERROR */
  UNKNOWN_ERROR: 0,
  /** PERMISSION_DENY */
  PERMISSION_DENY: 5100,
  /** AUTHENTICATION_ERROR */
  AUTHENTICATION_ERROR: 5200,
  /** INVALID_PARAMETERS */
  INVALID_PARAMETERS: 5300,
  /** DB_ERROR */
  DB_ERROR: 5400,
  /** NO_DATA */
  NO_DATA: 5500,
  /** EXPIRED_TOKEN */
  EXPIRED_TOKEN: 5600,
  /** TRANSACTION_FAILED */
  TRANSACTION_FAILED: 5700,
  /** INVALID_TOKEN */
  INVALID_TOKEN: 5800,
  /** UNABLE_TO_EXPORT_ORDERS */
  UNABLE_TO_EXPORT_ORDERS: 9001,
  /** UNABLE_TO_CREATE_ORDER_BATCH */
  UNABLE_TO_CREATE_ORDER_BATCH: 9002,
  /** 庫存不足 */
  INSUFFICIENT_INVENTORY: 9003,
  /** 外部訂單編號重複 */
  DUPLICATE_EXTERNAL_ORDER_ID: 9004,
  /** 必填欄位未填 */
  REQUIRED_FIELDS_MISSING: 9005,
  /** 更新失敗，訂單已被他人上鎖 */
  ORDER_LOCKED: 9006,
  /** 出貨單建立中，稍後重試即可 */
  OPERATION_IN_PROGRESS: 5001,
} as const

// 庫存驗證(9)
export const STOCK_VALIDATION_ERROR_CODES = {
  /** OUT_OF_STOCK */
  OUT_OF_STOCK: 9003,
} as const

// Coupon驗證(10)
export const COUPON_VALIDATION_ERROR_CODES = {
  /** COUPON_NO_TICKET */
  COUPON_NO_TICKET: 10001,
  /** COUPON_REACH_USER_LIMIT */
  COUPON_REACH_USER_LIMIT: 10002,
  /** COUPON_EXPIRED */
  COUPON_EXPIRED: 10003,
  /** COUPON_NO_PERMISSION */
  COUPON_NO_PERMISSION: 10004,
  /** COUPON_CODE_NOT_EXIST */
  COUPON_CODE_NOT_EXIST: 10005,
  /** MANUAL_COUPONS_FAILED */
  MANUAL_COUPONS_FAILED: 10006,
  /** WRONG_GIFT_SELECTION */
  WRONG_GIFT_SELECTION: 10007,
  /** KOL_COUPON_EXCEED */
  KOL_COUPON_EXCEED: 10008,
  /** USER_RESTRICTION */
  USER_RESTRICTION: 10009,
  /** INVALID_CRITERION_SELECTION */
  INVALID_CRITERION_SELECTION: 10011,
  /** LOSE_CRITERION_SELECTION */
  LOSE_CRITERION_SELECTION: 10012,
  /** COUPON_NOT_STARTED */
  COUPON_NOT_STARTED: 10022,
} as const

// 推薦碼驗證(11)
export const REFERRAL_COUPON_VALIDATION_ERROR_CODES = {
  /** REFERRAL_COUPON_INVALID */
  REFERRAL_COUPON_INVALID: 11001,
  /** REFERRAL_USE_ONE_COUPON */
  REFERRAL_USE_ONE_COUPON: 11002,
  /** REFERRAL_INVALID_PLATFORM */
  REFERRAL_INVALID_PLATFORM: 11003,
  /** REFERRAL_INVALID_FORMAT */
  REFERRAL_INVALID_FORMAT: 11004,
  /** NOT_OVER_MINIMUM_CART_THRESHOLD */
  NOT_OVER_MINIMUM_CART_THRESHOLD: 11005,
  /** OLD_CUSTOMER_USE_REFERRAL_COUPON */
  OLD_CUSTOMER_USE_REFERRAL_COUPON: 11006,
  /** OWNER_USE_REFERRAL_COUPON */
  OWNER_USE_REFERRAL_COUPON: 11007,
  /** REFERRAL_COUPON_BIND_STATUS_INVALID */
  REFERRAL_COUPON_BIND_STATUS_INVALID: 11008,
} as const

// 終身限購驗證(12)
export const LIFETIME_LIMITED_VALIDATION_ERROR_CODES = {
  /** LIFETIME_LIMITED_EXCEED */
  LIFETIME_LIMITED_EXCEED: 12001,
} as const

// 交易單相關錯誤(16)
export const TRANSACTION_ORDER_ERROR_CODES = {
  /** 該交易單不可被取消 */
  TRANSACTION_CANNOT_BE_CANCELLED: 16001,
  /** 黑名單手機號碼 */
  BLACKLISTED_PHONE_NUMBER: 16002,
  /** CART_NOT_FOUND */
  CART_NOT_FOUND: 16003,
  /** PAYMENT_NOT_CAPTURED */
  PAYMENT_NOT_CAPTURED: 16005,
} as const

// 出貨單相關錯誤(17)
export const SHIPPING_ORDER_ERROR_CODES = {
  /** 該出貨單不可被取消 */
  SHIPPING_ORDER_CANNOT_BE_CANCELLED: 17001,
} as const

// 訂單相關錯誤(18)
export const ORDER_ERROR_CODES = {
  /** 該訂單不可被取消 */
  ORDER_CANNOT_BE_CANCELLED: 18001,
  /** 建立訂單資料錯誤 */
  CREATE_ORDER_DATA_ERROR: 18002,
  /** 保留數量等於出貨數量 */
  RESERVE_QUANTITY_EQUALS_TO_QUANTITY: 18003,
  /** 訂單總額與交易金額不符 */
  ORDER_TOTAL_MISMATCH: 18006,
} as const

export const FORTUNE_GROUP_BUYING_AUTH_ERROR = 5950 as const
export const PAYMENT_EXCEPTION_CODES = {
  /**
   * CKO 情境失敗或尚未被處理（卡拒付、CKO 暫時異常等）。
   * response detail 帶 error_code / error_message（來自 FailedPaymentResult）。
   */
  PAYMENT_API_FAILED: 13001,
  /**
   * exec 進入時 Redis 分散式鎖衝突：同一 PaymentTransaction 已有另一個 flow 佔住鎖。
   * HTTP 409。尚未打到 gateway，短暫等待後重試通常可解。
   */
  CKO_PAYMENT_RECONCILING: 5001,
} as const

// 私密商品錯誤(15)
export const PRIVATE_PRODUCT_ERROR_CODES = {
  /** 私密商品 */
  PRIVATE_PRODUCT: 15001,
} as const

// 信用卡cardholder錯誤(16)
export const CARDHOLDER_ERROR_CODES = {
  NO_CARDHOLDER: 891,
  NAME_EN_RANGE: 740,
  NAME_EN_INVALID: 741,
  PHONE_NUMBER_INVALID: 742,
  PHONE_NUMBER_COUNTRY_CODE_INVALID: 743,
  EMAIL_INVALID: 744,
  PHONE_NUMBER_RANGE: 519,
}

export const SPECIFIC_ADDON_PRODUCT_EXCEPTION = {
  /** 當一個商品被標記為單品加價購的「加購品」(addonType: ADDON)，但它沒有提供 addonMainProductId 屬性來關聯對應的「主商品」。 */
  ADDON_MAIN_PRODUCT_ID_REQUIRED: 22013,
  /** 傳入的 addon_setting_id 在 coupons 資料表中找不到對應的紀錄 */
  ADDON_SETTING_NOT_FOUND: 22010,
  /** 無效的 addon_setting_id */
  INVALID_ADDON_SETTING: 22011,
  /** 加購品不在此加價購設定的適用商品清單中 */
  ADDON_PRODUCT_NOT_IN_CRITERION_GROUP: 22012,
  /** 針對同一個主商品和同一個加價購設定，所有加購品的總數量，超過了該加價購設定中對加購品的購買數量限制 (addon_purchase_limit)。 */
  PRODUCT_SPECIFIC_ADDON_PURCHASE_LIMIT_EXCEEDED: 22015,
  /** 相同消費門檻與生效期間已有相同加購品 */
  DUPLICATE_ADDON_PRODUCT_IN_GLOBAL_PERIOD: 22016,
} as const

// 預設物流商規則(24)
export const LOGISTICS_PROVIDER_RULE_ERROR_CODES = {
  /** 同一規則群組內，條件不可完全相同 */
  DUPLICATE_RULE_CONFIG: 24001,
  /** 規則群組名稱已存在 */
  DUPLICATE_RULE_GROUP_NAME: 24002,
  /** 經銷商群組不存在 */
  CUSTOMER_CATEGORY_NOT_FOUND: 24003,
  /** 經銷商不屬於指定的經銷商群組 */
  MERCHANT_NOT_IN_CATEGORY: 24004,
  /** 選擇經銷商群組或經銷商時，出貨對象類型不可為一般消費者或倉庫調撥 */
  INVALID_CUSTOMER_TYPE_WITH_MERCHANT: 24005,
  /** 商品清單檔案中含有無效的 real SKU */
  INVALID_PRODUCT_REAL_SKUS: 24006,
} as const

// 出貨單分類標籤(25)
export const SHIPMENT_LABEL_ERROR_CODES = {
  /** 主標籤不存在或不屬於該品牌/國家 */
  LABEL_NOT_FOUND: 25001,
  /** 互斥規則不可排除自己 */
  EXCLUSION_CANNOT_EXCLUDE_SELF: 25002,
  /** 該標籤已有互斥規則，請先刪除再重新設定 */
  EXCLUSION_ALREADY_EXISTS: 25003,
  /** 該標籤尚未設定互斥規則 */
  EXCLUSION_NOT_FOUND: 25004,
  /** 優先序必須從 1 開始連續，不可有間隔或重複 */
  INVALID_PRIORITY_SEQUENCE: 25005,
  /** 部分標籤不存在 */
  SOME_LABELS_NOT_FOUND: 25006,
  /** 所有標籤必須屬於同一個品牌和國家 */
  LABELS_MUST_SAME_PROJECT_COUNTRY: 25007,
  /** 系統預設標籤不可修改名稱 */
  SYSTEM_LABEL_NAME_IMMUTABLE: 25008,
  /** 系統預設標籤不可修改必要條件 */
  SYSTEM_LABEL_CONDITIONS_IMMUTABLE: 25009,
  /** 標籤名稱已存在 */
  DUPLICATE_LABEL_NAME: 25010,
  /** 非獨立出貨不可指定倉儲 */
  WAREHOUSES_NOT_ALLOWED: 25011,
  /** 指定經銷商時渠道僅可為 ToB 或不指定 */
  INVALID_CUSTOMER_TYPE_WITH_MERCHANT: 25012,
  /** 情境條件組必須包含配送方式 */
  CONTEXT_MISSING_SHIPPING_METHOD: 25013,
  /** 配送方式不允許選擇該物流商 */
  INVALID_LOGISTICS_FOR_SHIPPING_METHOD: 25014,
  /** 經銷商不屬於指定的經銷商群組 */
  MERCHANT_NOT_IN_CATEGORY: 25015,
  /** 經銷商不屬於指定的品牌/國家 */
  MERCHANT_NOT_IN_COUNTRY: 25016,
  /** 系統預設標籤不可刪除 */
  SYSTEM_LABEL_DELETE_FORBIDDEN: 25017,
  /** 商品清單檔案中含有無效的 real SKU */
  INVALID_PRODUCT_REAL_SKUS: 25018,
} as const
